import { render, staticRenderFns } from "./AcceptedDocumentsSection.vue?vue&type=template&id=56f0f1dc&scoped=true"
import script from "./AcceptedDocumentsSection.vue?vue&type=script&lang=js"
export * from "./AcceptedDocumentsSection.vue?vue&type=script&lang=js"
import style0 from "./AcceptedDocumentsSection.vue?vue&type=style&index=0&id=56f0f1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f0f1dc",
  null
  
)

export default component.exports